const urlSearchToObject = (searchParams) => {
  const obj = {};
  let params = searchParams;

  if (typeof (params) === 'string' || params instanceof String) params = new URLSearchParams(params);

  params.forEach((val, key) => {
    obj[key] = val;
  });

  return obj;
};

const cleanSearchParams = (...args) => {
  const newObj = Object.assign({}, ...args);

  Object.entries(newObj).forEach(([key, val]) => {
    if (val === undefined || val === null) delete newObj[key];
  });

  return newObj;
};

export {
  urlSearchToObject,
  cleanSearchParams,
};



// WEBPACK FOOTER //
// ./src/helpers/urlSearchParams.js